import { render, staticRenderFns } from "./Bianliuqi.vue?vue&type=template&id=ac98f36e&scoped=true&"
import script from "./Bianliuqi.vue?vue&type=script&lang=js&"
export * from "./Bianliuqi.vue?vue&type=script&lang=js&"
import style0 from "./Bianliuqi.vue?vue&type=style&index=0&id=ac98f36e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac98f36e",
  null
  
)

export default component.exports